import {Link} from '@primer/react'
import type {PendingWorkflowApprovalRollup} from '../../../page-data/payloads/status-checks'

interface WorkflowApprovalSubtitleProps {
  pendingWorkflowApprovalRollup: PendingWorkflowApprovalRollup
  className?: string
}

// Renders the descriptive subtitle for a pull request with workflow runs awaiting approval.
// Mirrors the messaging shown in the full mergebox approval prompt; the approve action itself
// is surfaced as an action on the ForYouItem header.
export function WorkflowApprovalSubtitle({pendingWorkflowApprovalRollup, className}: WorkflowApprovalSubtitleProps) {
  const {hasExpiredWorkflowRuns, approvalRequiredMessage, helpLink} = pendingWorkflowApprovalRollup

  if (hasExpiredWorkflowRuns) {
    return (
      <span className={className}>
        Unable to re-run one or more workflows because they were created over a month ago.
      </span>
    )
  }

  return (
    <span className={className}>
      {approvalRequiredMessage}{' '}
      <Link inline href={helpLink}>
        Learn more about approving workflows.
      </Link>
    </span>
  )
}
